module.exports = __webpack_public_path__ + "img/rotate-exclamation.0c246cb8.svg";